import { createI18n } from 'vue-i18n';
import Locales from '@/vue-i18n-locales.generated';

export const i18n = createI18n({
  legacy: false, // Composition APIモードを有効化
  globalInjection: true, // グローバル$tの利用を許可
  locale:
    document.querySelector('meta[name=trans-locale]').content
    || window.navigator.language
    || 'en',
  fallbackLocale:
    document.querySelector('meta[name=trans-fallback]').content || 'en',
  messages: Locales,
});

export const $t = i18n.global.t;
